<template>
  <div class="page">
    <van-nav-bar
      :title="convertLanage($route.meta ? $route.meta.title : '')"
      :fixed="true"
      left-arrow
      @click-left="handleToBeforePage"
    />
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
import { convertLanage } from '@/utils/lanage'
export default {
  name: 'Layout',
  methods: {
    /**
     * 简繁体语言转换
     */
    convertLanage(strs) {
      return convertLanage(strs)
    },
    /**
     * 跳转到上一个页面
     */
    handleToBeforePage() {
      this.$router.back()
    }
  }
}
</script>

<style lang="scss">
.page {
  padding-top: 90px;
  .van-nav-bar {
    background-color: #F9F9F9;
    .van-nav-bar__content {
      height: 90px;
      .van-nav-bar__left {
        .van-icon {
          color: rgba(0, 0, 0, 0.90);
        }
      }
      .van-nav-bar__title {
        color: #242424;
        font-size: 30px;
        font-weight: 500;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Layout.vue